import { categoryMeta } from "@/lib/skills/constants";
import type { Category } from "@/lib/skills/types";
import { cn } from "@/lib/utils";

export function CategoryTag({
  category,
  withIcon = true,
  className,
}: {
  category: Category;
  withIcon?: boolean;
  className?: string;
}) {
  const meta = categoryMeta(category);
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold",
        className,
      )}
      style={{ backgroundColor: meta.bg, color: meta.fg }}
    >
      {withIcon && <Icon className="size-3.5" />}
      {category}
    </span>
  );
}
